import { Collection } from 'modules/core/lib/mobx-rest'
import { apiClient } from 'modules/core/lib/mobx-rest'

import Document from 'modules/documents/store/models/Document'

class Documents extends Collection<Document> {
  get cacheKey(): string {
    return 'documents'
  }

  get indexes() {
    return ['employee_id', 'folder_id']
  }

  model() {
    return Document
  }

  async notifierFileUrl(id: string, recipient_id: string): Promise<string | null> {
    const { url } = await apiClient()
      .get(`${this.model().staticUrl()}/notifier_file_url`, {
        id: id,
        recipient_id: recipient_id,
      })
      .catch(() => {
        return { url: null }
      })

    return url
  }
}

const singleton: Documents = new Documents()

export { Documents }

export default singleton
